import { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { declineDelivery } from '../api';

// Owner Bookings & Cancellation v2 doc, Story 17 - "if a delivery person is unavailable for
// delivery on the particular date or time it should ask app owner and rental owner to assign it
// to another delivery person without hassle". This is the delivery person's half: a small popup
// to say why, which frees the slot and (server-side) surfaces a suggested replacement to the
// owner/admin - see AssignDeliveryModal's suggestedDeliveryPersonId / DeliveryList's "Reassign".
export default function DeclineDeliveryModal({ booking, show, onHide, onDeclined }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      setError('Please give a reason (e.g. unavailable on this date).');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const result = await declineDelivery(booking._id, reason.trim());
      setReason('');
      onDeclined(result);
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to decline this delivery.');
    } finally {
      setSubmitting(false);
    }
  };

  if (!booking) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Can't make this delivery</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-muted small">
            This lets the owner/admin know right away and frees the slot so someone else can be assigned.
          </p>
          {error && <Alert variant="danger" className="py-2">{error}</Alert>}
          <Form.Group controlId="decline-delivery-reason">
            <Form.Label className="small">Reason</Form.Label>
            <Form.Control
              as="textarea" rows={2} maxLength={500} required
              placeholder="e.g. Unavailable on this date, vehicle issue, ..."
              value={reason} onChange={(e) => setReason(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide} disabled={submitting}>Cancel</Button>
          <Button variant="danger" type="submit" disabled={submitting}>
            {submitting ? 'Submitting…' : 'Decline delivery'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
